
// @flow
import { chart } from './chart';
import '../src/css/sign.css';
import { toggleTheme } from './constants';

const chart1 = chart(document.getElementById('c1'), 'src/data/1', 'Followers');
const chart2 = chart(document.getElementById('c2'), 'src/data/2', 'Interactions');
const chart3 = chart(document.getElementById('c3'), 'src/data/3', 'Messages');
const chart4 = chart(document.getElementById('c4'), 'src/data/4', 'Views');
const chart5 = chart(document.getElementById('c5'), 'src/data/5', 'Apps');

const toggleThemeButton = document.getElementById('toggleTheme');
toggleThemeButton.addEventListener('click', () => {
    toggleTheme();
    document.body.classList.toggle('dark');
    if (document.body.classList.contains('dark')) {
        toggleThemeButton.textContent = 'Switch to Day Mode';
    } else {
        toggleThemeButton.textContent = 'Switch to Night Mode';
    }
}, false);
